var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLogin)?_c('div',{staticClass:"notice",class:{
    'red-dot': _vm.showRedDot,
  },on:{"click":_vm.clickEmail}},[_c('img',{staticClass:"img",attrs:{"src":require('@/assets/home/icon-email.png'),"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }